import { useTranslation } from 'react-i18next';
import FormLangBar from '../../FormLangBar';
import { MwInputText,MwTextArea,MwSwitch } from '../../ui';
import {
    PRODUCT_FORM_SECTION_CLASS,
    PRODUCT_OPTION_LABEL_CLASS,
    PRODUCT_OPTION_ROW_CLASS,
} from '../productUi';

const TagForm = ({
    currentLangList,
    formLang,
    setFormLang,
    errors,
    tagName,
    setTagName,
    tagDesc,
    setTagDesc,
    isActive,
    setIsActive

}) => {
    const [t] = useTranslation('global')
    return (
        <form className='space-y-4'>
            <div id='MultiLangBlock' className='flex flex-col'>
                <FormLangBar currentLangList = {currentLangList} formLang = {formLang} setFormLang = {setFormLang} />
                { currentLangList.map((lang) => (
                    <div key={lang.langCode} className={`${PRODUCT_FORM_SECTION_CLASS} ${formLang === lang?.langCode ? 'block' : 'hidden'}`}>
                        <MwInputText
                            label={`${t('product.tag_name_label')} (${lang?.langName})`}
                            id={`tagName${lang?.langCode}`} 
                            placeholder={`${t('product.tag_name_label')} (${lang?.langName})`}
                            value={tagName[lang?.langCode]}
                            invalid={!!errors[`tagName.${lang?.langCode}`] }
                            invalidMsg = {errors[`tagName.${lang?.langCode}`]}
                            onChange={(e)=>{
                                setTagName({...tagName, [lang?.langCode]:e.target.value});
                            }}
                        />
                        <div className='mt-3'>
                            <MwTextArea
                                id={`tagDesc${lang?.langCode}`}
                                label={`${t('product.tag_desc_placeholder')} (${lang.langName})`}
                                value={tagDesc[lang?.langCode]}
                                placeholder={`${t('product.tag_desc_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setTagDesc({...tagDesc,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                    </div>
                )) }
            </div>
            <div id='OptionsBock' className='flex flex-col gap-3'>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>{t('product.activation_status')}</label>
                    <MwSwitch custKey='isActive' setIsActive= {setIsActive} isActive={isActive} onChangeSwitch={() => setIsActive(!isActive)} />
                </div>
            </div>
        </form>
    )
}

export default TagForm
